import cx from 'classnames'

const Pricing = (props) => (
  <div className={ cx('pricing', `is__currency${props.currency}`) }>
    <div className="pricing-in">{ props.children }</div>
  </div>
)

export default Pricing
